import { createApiReducer } from 'reacticoon/reducer'
import { postRegister } from './actions'

const registerReducer = createApiReducer(postRegister)

export default registerReducer
